<template>
  <v-overlay
    absolute
    :value="status"
  >
    <v-progress-circular
      v-if="status"
      indeterminate
      color="primary"
    />
  </v-overlay>
</template>

<script>
export default {
  props: ["status"],

}
</script>

<style>

</style>